// Country dial codes for the phone country-code picker.
// Reference copy — keep in sync with COUNTRY_DIAL_CODES in
// talentino-app/api/utils/phone.py, which normalizes phones server-side.

// [iso2, dialCode, name, ...aliases]
export const COUNTRY_DIAL_CODES = [
  ['US', '1', 'United States', 'United States Minor Outlying Islands', 'USA'],
  ['CA', '1', 'Canada'],
  ['BS', '1242', 'Bahamas'],
  ['BB', '1246', 'Barbados'],
  ['AI', '1264', 'Anguilla'],
  ['AG', '1268', 'Antigua and Barbuda'],
  ['VG', '1284', 'Virgin Islands, British', 'British Virgin Islands'],
  ['VI', '1340', 'Virgin Islands, U.S.', 'U.S. Virgin Islands'],
  ['KY', '1345', 'Cayman Islands'],
  ['BM', '1441', 'Bermuda'],
  ['GD', '1473', 'Grenada'],
  ['TC', '1649', 'Turks and Caicos Islands'],
  ['MS', '1664', 'Montserrat'],
  ['MP', '1670', 'Northern Mariana Islands'],
  ['GU', '1671', 'Guam'],
  ['AS', '1684', 'American Samoa'],
  ['SX', '1721', 'Sint Maarten'],
  ['LC', '1758', 'Saint Lucia'],
  ['DM', '1767', 'Dominica'],
  ['VC', '1784', 'Saint Vincent and the Grenadines'],
  ['PR', '1787', 'Puerto Rico'],
  ['DO', '1809', 'Dominican Republic'],
  ['TT', '1868', 'Trinidad and Tobago'],
  ['KN', '1869', 'Saint Kitts and Nevis'],
  ['JM', '1876', 'Jamaica'],
  ['EG', '20', 'Egypt'],
  ['SS', '211', 'South Sudan'],
  ['MA', '212', 'Morocco'],
  ['EH', '212', 'Western Sahara'],
  ['DZ', '213', 'Algeria'],
  ['TN', '216', 'Tunisia'],
  ['LY', '218', 'Libya', 'Libyan Arab Jamahiriya'],
  ['GM', '220', 'Gambia'],
  ['SN', '221', 'Senegal'],
  ['MR', '222', 'Mauritania'],
  ['ML', '223', 'Mali'],
  ['GN', '224', 'Guinea'],
  ['CI', '225', "Cote D'Ivoire", "Côte d'Ivoire", 'Ivory Coast'],
  ['BF', '226', 'Burkina Faso'],
  ['NE', '227', 'Niger'],
  ['TG', '228', 'Togo'],
  ['BJ', '229', 'Benin'],
  ['MU', '230', 'Mauritius'],
  ['LR', '231', 'Liberia'],
  ['SL', '232', 'Sierra Leone'],
  ['GH', '233', 'Ghana'],
  ['NG', '234', 'Nigeria'],
  ['TD', '235', 'Chad'],
  ['CF', '236', 'Central African Republic'],
  ['CM', '237', 'Cameroon'],
  ['CV', '238', 'Cape Verde'],
  ['ST', '239', 'Sao Tome and Principe'],
  ['GQ', '240', 'Equatorial Guinea'],
  ['GA', '241', 'Gabon'],
  ['CG', '242', 'Congo'],
  ['CD', '243', 'Congo, The Democratic Republic of the', 'DR Congo'],
  ['AO', '244', 'Angola'],
  ['GW', '245', 'Guinea-Bissau'],
  ['IO', '246', 'British Indian Ocean Territory'],
  ['SC', '248', 'Seychelles'],
  ['SD', '249', 'Sudan'],
  ['RW', '250', 'Rwanda'],
  ['ET', '251', 'Ethiopia'],
  ['SO', '252', 'Somalia'],
  ['DJ', '253', 'Djibouti'],
  ['KE', '254', 'Kenya'],
  ['TZ', '255', 'Tanzania', 'Tanzania, United Republic of'],
  ['UG', '256', 'Uganda'],
  ['BI', '257', 'Burundi'],
  ['MZ', '258', 'Mozambique'],
  ['ZM', '260', 'Zambia'],
  ['MG', '261', 'Madagascar'],
  ['RE', '262', 'Reunion', 'French Southern Territories'],
  ['YT', '262', 'Mayotte'],
  ['ZW', '263', 'Zimbabwe'],
  ['NA', '264', 'Namibia'],
  ['MW', '265', 'Malawi'],
  ['LS', '266', 'Lesotho'],
  ['BW', '267', 'Botswana'],
  ['SZ', '268', 'Swaziland', 'Eswatini'],
  ['KM', '269', 'Comoros'],
  ['ZA', '27', 'South Africa'],
  ['SH', '290', 'Saint Helena'],
  ['ER', '291', 'Eritrea'],
  ['AW', '297', 'Aruba'],
  ['FO', '298', 'Faroe Islands'],
  ['GL', '299', 'Greenland'],
  ['GR', '30', 'Greece'],
  ['NL', '31', 'Netherlands'],
  ['BE', '32', 'Belgium'],
  ['FR', '33', 'France'],
  ['ES', '34', 'Spain'],
  ['GI', '350', 'Gibraltar'],
  ['PT', '351', 'Portugal'],
  ['LU', '352', 'Luxembourg'],
  ['IE', '353', 'Ireland'],
  ['IS', '354', 'Iceland'],
  ['AL', '355', 'Albania'],
  ['MT', '356', 'Malta'],
  ['CY', '357', 'Cyprus'],
  ['FI', '358', 'Finland'],
  ['BG', '359', 'Bulgaria'],
  ['HU', '36', 'Hungary'],
  ['LT', '370', 'Lithuania', 'Republic of Lithuania'],
  ['LV', '371', 'Latvia'],
  ['EE', '372', 'Estonia'],
  ['MD', '373', 'Moldova, Republic of', 'Moldova', 'Republic of Moldova'],
  ['AM', '374', 'Armenia'],
  ['BY', '375', 'Belarus'],
  ['AD', '376', 'Andorra'],
  ['MC', '377', 'Monaco'],
  ['SM', '378', 'San Marino'],
  ['VA', '379', 'Holy See (Vatican City State)', 'Vatican City'],
  ['UA', '380', 'Ukraine'],
  ['RS', '381', 'Serbia'],
  ['ME', '382', 'Montenegro'],
  ['XK', '383', 'Kosovo'],
  ['HR', '385', 'Croatia'],
  ['SI', '386', 'Slovenia'],
  ['BA', '387', 'Bosnia and Herzegovina'],
  [
    'MK',
    '389',
    'Macedonia',
    'Macedonia, The Former Yugoslav Republic of',
    'North Macedonia',
  ],
  ['IT', '39', 'Italy'],
  ['RO', '40', 'Romania'],
  ['CH', '41', 'Switzerland'],
  ['CZ', '420', 'Czech Republic', 'Czechia'],
  ['SK', '421', 'Slovakia'],
  ['LI', '423', 'Liechtenstein'],
  ['AT', '43', 'Austria'],
  ['GB', '44', 'United Kingdom', 'Guernsey', 'Jersey', 'Isle of Man', 'UK'],
  ['DK', '45', 'Denmark'],
  ['SE', '46', 'Sweden'],
  ['NO', '47', 'Norway', 'Svalbard and Jan Mayen'],
  ['PL', '48', 'Poland'],
  ['DE', '49', 'Germany'],
  [
    'FK',
    '500',
    'Falkland Islands (Malvinas)',
    'South Georgia and the South Sandwich Islands',
  ],
  ['BZ', '501', 'Belize'],
  ['GT', '502', 'Guatemala'],
  ['SV', '503', 'El Salvador'],
  ['HN', '504', 'Honduras'],
  ['NI', '505', 'Nicaragua'],
  ['CR', '506', 'Costa Rica'],
  ['PA', '507', 'Panama'],
  ['PM', '508', 'Saint Pierre and Miquelon'],
  ['HT', '509', 'Haiti'],
  ['PE', '51', 'Peru'],
  ['MX', '52', 'Mexico'],
  ['CU', '53', 'Cuba'],
  ['AR', '54', 'Argentina'],
  ['BR', '55', 'Brazil'],
  ['CL', '56', 'Chile'],
  ['CO', '57', 'Colombia'],
  ['VE', '58', 'Venezuela'],
  ['GP', '590', 'Guadeloupe'],
  ['BO', '591', 'Bolivia'],
  ['GY', '592', 'Guyana'],
  ['EC', '593', 'Ecuador'],
  ['GF', '594', 'French Guiana'],
  ['PY', '595', 'Paraguay'],
  ['MQ', '596', 'Martinique'],
  ['SR', '597', 'Suriname'],
  ['UY', '598', 'Uruguay'],
  ['CW', '599', 'Netherlands Antilles', 'Curacao'],
  ['MY', '60', 'Malaysia'],
  ['AU', '61', 'Australia', 'Christmas Island', 'Cocos (Keeling) Islands'],
  ['ID', '62', 'Indonesia'],
  ['PH', '63', 'Philippines'],
  ['NZ', '64', 'New Zealand', 'Pitcairn'],
  ['SG', '65', 'Singapore'],
  ['TH', '66', 'Thailand'],
  ['TL', '670', 'Timor-Leste'],
  [
    'NF',
    '672',
    'Norfolk Island',
    'Antarctica',
    'Heard Island and Mcdonald Islands',
  ],
  ['BN', '673', 'Brunei', 'Brunei Darussalam'],
  ['NR', '674', 'Nauru'],
  ['PG', '675', 'Papua New Guinea'],
  ['TO', '676', 'Tonga'],
  ['SB', '677', 'Solomon Islands'],
  ['VU', '678', 'Vanuatu'],
  ['FJ', '679', 'Fiji'],
  ['PW', '680', 'Palau'],
  ['WF', '681', 'Wallis and Futuna'],
  ['CK', '682', 'Cook Islands'],
  ['NU', '683', 'Niue'],
  ['WS', '685', 'Samoa'],
  ['KI', '686', 'Kiribati'],
  ['NC', '687', 'New Caledonia'],
  ['TV', '688', 'Tuvalu'],
  ['PF', '689', 'French Polynesia'],
  ['TK', '690', 'Tokelau'],
  ['FM', '691', 'Micronesia, Federated States of'],
  ['MH', '692', 'Marshall Islands'],
  ['RU', '7', 'Russia', 'Russian Federation'],
  ['KZ', '7', 'Kazakhstan'],
  ['JP', '81', 'Japan'],
  ['KR', '82', 'South Korea', 'Republic of Korea'],
  ['VN', '84', 'Viet Nam', 'Vietnam'],
  ['CN', '86', 'China'],
  ['HK', '852', 'Hong Kong'],
  ['MO', '853', 'Macao', 'Macau'],
  ['KH', '855', 'Cambodia'],
  ['LA', '856', 'Lao People"S Democratic Republic', 'Laos'],
  ['BD', '880', 'Bangladesh'],
  ['TW', '886', 'Taiwan', 'Taiwan, Province of China'],
  ['TR', '90', 'Turkey', 'Turkiye'],
  ['IN', '91', 'India'],
  ['PK', '92', 'Pakistan'],
  ['AF', '93', 'Afghanistan'],
  ['LK', '94', 'Sri Lanka'],
  ['MM', '95', 'Myanmar', 'Myanmar [Burma]'],
  ['MV', '960', 'Maldives'],
  ['LB', '961', 'Lebanon'],
  ['JO', '962', 'Jordan', 'Hashemite Kingdom of Jordan'],
  ['SY', '963', 'Syrian Arab Republic', 'Syria'],
  ['IQ', '964', 'Iraq'],
  ['KW', '965', 'Kuwait'],
  ['SA', '966', 'Saudi Arabia'],
  ['YE', '967', 'Yemen'],
  ['OM', '968', 'Oman'],
  ['PS', '970', 'Palestine'],
  ['AE', '971', 'United Arab Emirates', 'UAE'],
  ['IL', '972', 'Israel'],
  ['BH', '973', 'Bahrain'],
  ['QA', '974', 'Qatar'],
  ['BT', '975', 'Bhutan'],
  ['MN', '976', 'Mongolia'],
  ['NP', '977', 'Nepal'],
  ['IR', '98', 'Iran', 'Iran, Islamic Republic Of'],
  ['TJ', '992', 'Tajikistan'],
  ['TM', '993', 'Turkmenistan'],
  ['AZ', '994', 'Azerbaijan'],
  ['GE', '995', 'Georgia'],
  ['KG', '996', 'Kyrgyzstan'],
  ['UZ', '998', 'Uzbekistan'],
]

export const DEFAULT_COUNTRY_ISO2 = 'EG'
